var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgThinCloseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.762451 0.200012L0.199951 0.762512L4.44995 5.00001L0.199951 9.23751L0.762451 9.80001L5.02495 5.56251L9.27495 9.80001L9.83745 9.23751L5.58745 5.00001L9.83745 0.762512L9.27495 0.200012L5.02495 4.43751L0.762451 0.200012Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThinCloseIcon);
export default __webpack_public_path__ + "static/media/thinCloseIcon.141d0e54d37ba7941aed7200f82705bc.svg";
export { ForwardRef as ReactComponent };